import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import {
  DefaultButton,
  DefaultPrimaryButton,
  Input,
  InputWithLabel,
  RadioButton,
  SelectBox,
} from "../../components/micro/input";
import Toggles from "../../components/common/Toggles";
import FileUploadChoose from "../../components/common/FileUploadChoose";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import { useDispatch, useSelector } from "react-redux";
import { createProduct, uploadImage } from "../../redux/product/slice";
import { getCategoriesList } from "../../redux/categories/slice";
import { toast } from "react-toastify";
import Breadcrumb from "../../components/common/BreadCrumb";
import { InputError } from "../../components/error/error";
import ContractPreviewModal from "./ContractPreviewModal";

const CreateEditRecurring = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isEditMode = location?.state?.mode;
  const [isEditing, setIsEditing] = useState(false);
  const [isToggle, setIsToggle] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [resetForm, setResetForm] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [allCategoriesListArray, setAllCategoriesListArray] = useState("");
  const [selectedCategories, setSelectedCategories] = useState(null);
  const productData = location?.state?.product;
  const [isPreviewOpen, setPreviewOpen] = useState(false);
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [showContractPreviewModal, setShowContractPreviewModal] =
    useState(false);

  const handleCreate = () => {
    setPreviewOpen(false);
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    // Handle confirmation logic
    setConfirmOpen(false);
  };

  useEffect(() => {
    if (productData?.images?.length) {
      const uploadeFiles = productData?.images?.map((element) => {
        return element?.document?.url;
      });
      setUploadedFiles(uploadeFiles);
    }
  }, []);

  // selector
  const { allCategoriesList, allCategoriesLoading } = useSelector((store) => ({
    allCategoriesList: store?.categoriesData?.getCategoriesListStatus?.data,
    allCategoriesLoading: store?.categoriesData?.loading,
  }));

  useEffect(() => {
    dispatch(getCategoriesList({ search: "", limit: "all" }));
  }, []);

  useEffect(() => {
    if (allCategoriesList?.data) {
      let data = allCategoriesList?.data?.map((x) => ({ ...x, label: x.name }));
      setAllCategoriesListArray(data);
    }
  }, [allCategoriesList]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
  };

  useEffect(() => {
    if (isEditMode === "edit" && productData) {
      if (Array.isArray(allCategoriesListArray)) {
        const foundCategory = allCategoriesListArray.find(
          (category) => category.id === productData.category_id
        );
        setSelectedCategories(foundCategory || null);
      }
      if (productData?.images?.length) {
        const imgArray = productData?.images?.map((e) => {
          return e?.id;
        });
        setImageUrls(imgArray);
      }
    }
  }, [isEditMode, productData, allCategoriesListArray]);

  useEffect(() => {
    if (isEditMode === "edit" && productData) {
      setIsToggle(productData.fixed_price === 1);
      if (Array.isArray(allCategoriesListArray)) {
        const foundCategory = allCategoriesListArray.find(
          (category) => category.id === productData.category_id
        );
        setSelectedCategories(foundCategory || null);
      }
      if (productData?.images?.length) {
        const imgArray = productData?.images?.map((e) => {
          return e?.id;
        });
        setImageUrls(imgArray);
      }
    }
  }, [isEditMode, productData, allCategoriesListArray]);

  const companyList = [
    { label: "Electronics", value: 1 },
    { label: "Furniture", value: 2 },
    { label: "Clothing", value: 3 },
  ];

  const frequencyOptions = [
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
    { label: "Yearly", value: "yearly" },
  ];

  const salesManager = [
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
    { label: "Yearly", value: "yearly" },
  ];

  return (
    <>
      <div className="mb-3">
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">
            Create Recurring Contract
          </h6>
          <Breadcrumb
            breadCrumbParent={"Home"}
            breadCrumbActive={"Create Contract"}
            breadCrumbParent2={"Recurring Contract"}
            breadCrumbTitleKey={"/"}
            classes=""
          />
        </div>
      </div>
      <div className="bg-white shadow-md rounded-lg p-6">
        <h6 className="font-Montserrat font-medium text-xl mb-3">
          {" "}
          {isEditMode == "edit"
            ? "Edit Recurring Contract"
            : "New Recurring Contract"}{" "}
        </h6>
        <Formik
          initialValues={{
            companyName: "",
            recurringFrequency: "",
            customerFullName: "",
            salesManager: "",
            startDate: "",
            endDate: "",
            numberOfServices: "",
            price: "",
            recurringContract: "outlet",
          }}
          validationSchema={Yup.object().shape({
            // companyName: Yup.string().required("Required"),
            // recurringFrequency: Yup.string().required("Required"),
            // customerFullName: Yup.string().required("Required"),
            // salesManager: Yup.string().required("Required"),
            // startDate: Yup.string().required("Required"),
            // endDate: Yup.string().required("Required"),
            // numberOfServices: Yup.number().required("Required").positive(),
            // price: Yup.number().required("Required").positive(),
          })}
          onSubmit={(values, { resetForm }) => {
            setFormValues(values);
            setShowConfirmationModal(true);
            setResetForm(() => resetForm);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div>
                {/* Radio Buttons */}
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Recurring Contract
                  </label>
                  <div className="gap-4 grid">
                    <label className="flex items-center">
                      <RadioButton
                        type="radio"
                        name="recurringContract"
                        value="outlet"
                        checked={values.recurringContract === "outlet"}
                        onChange={handleChange}
                        className="text-base text-left font-normal font-Proxima"
                      />
                      <span className="ml-2 text-sm text-gray-800">
                        For each outlet
                      </span>
                    </label>
                    <label className="flex items-center">
                      <RadioButton
                        type="radio"
                        name="recurringContract"
                        value="company"
                        checked={values.recurringContract === "company"}
                        onChange={handleChange}
                        className="text-base text-left font-normal font-Proxima"
                      />
                      <span className="ml-2 text-sm text-gray-800">
                        As a whole company
                      </span>
                    </label>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-6 mb-6">
                  {/* Company Name */}
                  <div>
                    <ReactSelect
                      type="text"
                      id="companyName"
                      name="companyName"
                      onChange={handleChange}
                      placeholder=" Company Name"
                      onBlur={handleBlur}
                      options={companyList}
                      value={values.companyName}
                      errors={errors.companyName && touched.companyName}
                      errorsText={errors.companyName}
                      disabled={isEditMode === "edit" && !isEditing}
                      className={`${
                        isEditMode === "edit" && !isEditing
                          ? "text-textGrey border border-dashed bg-white"
                          : "text-black  hover:border-themeBtn "
                      }  ${
                        errors.companyName && touched.companyName
                          ? `border border-red`
                          : ` border-borderTheme/80`
                      } relative bg-white transition duration-300 rounded w-full text-black p-0`}
                    />
                  </div>

                  {/* Recurring Frequency */}
                  <div>
                    <ReactSelect
                      type="text"
                      id="recurringFrequency"
                      name="recurringFrequency"
                      onChange={handleChange}
                      options={frequencyOptions}
                      onBlur={handleBlur}
                      placeholder="Recurring Frequency"
                      value={values.recurringFrequency}
                      className={`${
                        isEditMode === "edit" && !isEditing
                          ? "text-textGrey border border-dashed bg-white"
                          : "text-black  hover:border-themeBtn "
                      }  ${
                        errors.recurringFrequency && touched.recurringFrequency
                          ? `border border-red`
                          : ` border-borderTheme/80`
                      } relative bg-white transition duration-300 rounded w-full text-black p-0`}
                    />
                    {errors.recurringFrequency &&
                      touched.recurringFrequency && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.recurringFrequency}
                        </p>
                      )}
                  </div>

                  {/* Customer Full Name */}
                  <div>
                    <InputWithLabel
                      idFromName="customerFullName"
                      label="Customer Name"
                      type="text"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.customerFullName}
                      className={`${
                        isEditMode === "edit" && !isEditing
                          ? "text-textGrey border border-dashed "
                          : "text-black border hover:border-themeBtn"
                      }  ${
                        errors.customerFullName && touched.customerFullName
                          ? `border border-red`
                          : `border border-borderTheme/80 focus-within:border-themeBtn `
                      }  transition duration-300 ease-in-out`}
                    />
                    {errors.customerFullName && touched.customerFullName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.customerFullName}
                      </p>
                    )}
                  </div>

                  {/* Sales Manager */}
                  <div>
                    <ReactSelect
                      type="text"
                      id="salesManager"
                      name="salesManager"
                      placeholder="Sales Manager"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.salesManager}
                      className={`${
                        isEditMode === "edit" && !isEditing
                          ? "text-textGrey border border-dashed bg-white"
                          : "text-black  hover:border-themeBtn "
                      }  ${
                        errors.salesManager && touched.salesManager
                          ? `border border-red`
                          : ` border-borderTheme/80`
                      } relative bg-white transition duration-300 rounded w-full text-black p-0`}
                    />
                    {errors.salesManager && touched.salesManager && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.salesManager}
                      </p>
                    )}
                  </div>

                  {/* Start Date */}
                  <div>
                    <InputWithLabel
                      type="date"
                      id="startDate"
                      label="Start Date"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={salesManager}
                      value={values.startDate}
                      className={`${
                        isEditMode === "edit" && !isEditing
                          ? "text-textGrey border border-dashed "
                          : "text-black border hover:border-themeBtn"
                      }  ${
                        errors.startDate && touched.startDate
                          ? `border border-red`
                          : `border border-borderTheme/80 focus-within:border-themeBtn `
                      }  transition duration-300 ease-in-out`}
                    />
                  </div>

                  {/* End Date */}
                  <div>
                    <InputWithLabel
                      type="date"
                      id="endDate"
                      label="End Date"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.endDate}
                      className={`${
                        isEditMode === "edit" && !isEditing
                          ? "text-textGrey border border-dashed "
                          : "text-black border hover:border-themeBtn"
                      }  ${
                        errors.endDate && touched.endDate
                          ? `border border-red`
                          : `border border-borderTheme/80 focus-within:border-themeBtn `
                      }  transition duration-300 ease-in-out`}
                    />
                    {errors.endDate && touched.endDate && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.endDate}
                      </p>
                    )}
                  </div>

                  {/* Number of Services */}
                  <div>
                    <InputWithLabel
                      type="number"
                      id="numberOfServices"
                      name="numberOfServices"
                      label="Number of Services"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.numberOfServices}
                      className={`${
                        isEditMode === "edit" && !isEditing
                          ? "text-textGrey border border-dashed "
                          : "text-black border hover:border-themeBtn"
                      }  ${
                        errors.numberOfServices && touched.numberOfServices
                          ? `border border-red`
                          : `border border-borderTheme/80 focus-within:border-themeBtn `
                      }  transition duration-300 ease-in-out`}
                    />
                    {errors.numberOfServices && touched.numberOfServices && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.numberOfServices}
                      </p>
                    )}
                  </div>

                  {/* Price */}
                  <div>
                    <InputWithLabel
                      type="number"
                      id="price"
                      name="price"
                      label=" Price ($)"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.price}
                      className={`${
                        isEditMode === "edit" && !isEditing
                          ? "text-textGrey border border-dashed "
                          : "text-black border hover:border-themeBtn"
                      }  ${
                        errors.price && touched.price
                          ? `border border-red`
                          : `border border-borderTheme/80 focus-within:border-themeBtn `
                      }  transition duration-300 ease-in-out`}
                    />
                    {errors.price && touched.price && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.price}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="flex justify-end mt-3">
                {isEditMode === "edit" ? (
                  isEditing ? (
                    <>
                      <div className="flex gap-2">
                        <DefaultPrimaryButton
                          type="submit"
                          value="Cancel"
                          onClick={handleCancelClick}
                        />
                        <DefaultButton type="submit" value="Save" />
                      </div>
                    </>
                  ) : (
                    <DefaultButton
                      value="Edit"
                      onClick={handleEditClick}
                      type="submit"
                    />
                  )
                ) : (
                  <DefaultButton type="submit" value="Preview" />
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {/* {showConfirmationModal && (
        <div>
          <ConfirmationModel
            confirmText={isEditMode === "edit" ? "Edit" : "Create"}
            onClose={() => setShowConfirmationModal(false)}
            onConfirm={() => handleConfirm(resetForm)}
            isLoading={isLoading}
          />
        </div>
      )} */}
      {showConfirmationModal && (
        <ContractPreviewModal
          onClose={() => setShowConfirmationModal(false)}
          onConfirm={handleCreate}
          modal={"true"}
        />
      )}
    </>
  );
};

export default CreateEditRecurring;
